<template>
  <div class="company-registration-form">
    <div class="full-frame-container">
      <!-- Embed Form -->
      <div class="embed-iframe">
        <iframe class="full-iframe" src="https://forms.cloud.microsoft/r/TDZ2gHbHAx" frameborder="0" marginheight="0" marginwidth="0" max-width="100%" sandbox="allow-forms allow-modals allow-orientation-lock allow-popups allow-same-origin allow-scripts" scrolling="no" style="border: none; max-width: 100%; max-height: 100vh" allowfullscreen mozallowfullscreen msallowfullscreen webkitallowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'company-registration-form',
  metaInfo () {
    console.log('metaInfo being called in Company Registration Form')
    const title = 'Tyng & Co | Company Registration Form'
    const description = 'Company Registration Form'
    document.querySelector('meta[name="description"]').content = description
    return {
      title,
      titleTemplate: null,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: description
        }
      ],
      link: [{
        rel: 'canonical',
        href: `https://tyng-ca.com.my/${this.$i18n.locale}/company-registration-form`
      }]
    }
  }
}
</script>
